var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleQuotesYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#AF8600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4167 11.6789C25.4469 12.7726 26.0001 14 26.0001 15.9897C26.0001 19.4891 23.5436 22.6263 19.9695 24.1768L19.0768 22.7992C22.4121 20.9946 23.0639 18.6539 23.3245 17.178C22.7875 17.4557 22.0845 17.5533 21.3954 17.4895C19.591 17.3222 18.1689 15.8409 18.1689 14C18.1689 12.067 19.7359 10.5 21.6689 10.5C22.742 10.5 23.7681 10.9904 24.4167 11.6789ZM14.4167 11.6789C15.4469 12.7726 16.0001 14 16.0001 15.9897C16.0001 19.4891 13.5436 22.6263 9.96951 24.1768L9.07682 22.7992C12.4121 20.9946 13.0639 18.6539 13.3245 17.178C12.7875 17.4557 12.0845 17.5533 11.3954 17.4895C9.59102 17.3222 8.16895 15.8409 8.16895 14C8.16895 12.067 9.73595 10.5 11.6689 10.5C12.742 10.5 13.7681 10.9904 14.4167 11.6789Z",
    fill: "#AF8600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuotesYellow);
export default __webpack_public_path__ + "static/media/double-quotes-yellow.257dd124b72cebf6afbd341da0eff922.svg";
export { ForwardRef as ReactComponent };